import { createRoutine } from 'redux-saga-routines';

export const fetchWebhooks = createRoutine('FETCH_WEBHOOKS');
export const fetchWebhookById = createRoutine('FETCH_WEBHOOK_BY_ID');

export const createWebhook = createRoutine('CREATE_WEBHOOK');
export const editWebhook = createRoutine('EDIT_WEBHOOK');
export const editWebhookStatus = createRoutine('EDIT_WEBHOOK_STATUS');

export const deleteWebhook = createRoutine('DELETE_WEBHOOK');

export const testWebhook = createRoutine('TEST_WEBHOOK');

export const fetchWebhookActivities = createRoutine('FETCH_WEBHOOK_ACTIVITIES');
